import { Grid, Paper } from "@mui/material";
import { useSelector } from "react-redux";
import { selectAuthError } from "../../store/auth/auth.reducer";
import { StoreState } from "../../store";
import { SignoutPanel } from "./signout";

/**
 * Page affichée lorsqu'il y a eu une erreur d'authentification côté front.
 */
const AuthError = () => {
	const authError = useSelector((state: StoreState) => selectAuthError(state.auth));
	//TODO Design et contenu à compléter ...
	//TODO Design à finaliser
	return (
		<Paper>
			<Grid container alignContent="center">
				<Grid item xs={6}>
					<h3>Erreur d'authentification :</h3>
					<p>{authError}</p>
				</Grid>
			</Grid>
			<SignoutPanel />
		</Paper>
	);
};

export default AuthError;
